import BottomButtonWrapper from "../BottomButtonWrapper";
import Button from "../Button";
import ListItem from "../ListItem";
import {useState} from "react";
import {Price, safeRedirect} from "../../tools/helpers";
import {Reoverlay} from "reoverlay";
import PolicyModal from "../modals/PolicyModal";
import ErrorModal from "../modals/ErrorModal";
import {useNavigate} from "react-router-dom";


const Payment = (props) => {

    const {payment, handlePayment} = props;
    const navigate=useNavigate();
    const [acceptPolicy, setAcceptPolicy] = useState(false);
    const handleAcceptPolicy = (e) => {
        setAcceptPolicy(e.target.checked)
    }
    const handlePolicyModal = () => {
        Reoverlay.showModal(PolicyModal)
    }


    return <div className=" p-3">
        <div className="w-full flex bg-white mx-auto lg:w-5/12 xl:w-4/12  p-5 rounded-lg justify-center flex-col items-center  ">
            <div className="flex justify-center w-full items-center flex-col mb-2 border-b">
                <h1 className="text-green-500 text-xl text-center font-bold">پرداخت</h1>
                <p className=" mb-4 text-sm"> برای ادامه مراحل ابتدا پرداخت را انجام دهید</p>
            </div>
            <div className=" mb-4  overflow-hidden w-full">
                <ListItem value={+payment?.info?.original_price/10} priceUnit="تومان" isPrice={true} title="مبلغ"/>
                <ListItem value={payment?.info?.discount_amount/10} priceUnit="تومان" isPrice={true} title="مبلغ تخفیف داده شده"/>
                <ListItem value={payment?.info?.fee_percent} isPercent={true} title="درصد مالیات بر ارزش افزوده"/>
                <ListItem value={payment?.info?.total_amount/10} priceUnit="تومان" isPrice={true} title="مبلغ پرداختی"/>
            </div>

            <div className="flex justify-between mt-2 w-full  py-3 border-t">
                <div className="flex justify-start items-center ">
                    <span className="text-xs">قوانین را می‌پذیرم</span>
                    <input className="mx-2" onChange={handleAcceptPolicy} type="checkbox" checked={acceptPolicy}/>
                </div>
                <span onClick={handlePolicyModal} className="text-blue-400 text-xs underline ">مطالعه قوانین</span>
            </div>

        </div>


        <BottomButtonWrapper>
            <div className="pt-1 pb-3  px-3 flex justify-between items-center">
                <span>مبلغ پرداختی</span>
                <strong
                    className="text-green-500">{Price(payment?.info?.total_amount ? payment?.info?.total_amount/10 : payment?.info?.original_price/10)}<span>تومان</span></strong>
            </div>
            <div className="grid grid-cols-1 border-t border-gray-100    pt-6 ">
                <Button onClick={() => {

                    if (payment?.pay_url) {

                        safeRedirect(payment?.pay_url,()=>{
                            Reoverlay.showModal(ErrorModal,{
                                title:'خطا',
                                message:'لینک معتبر نمی باشد.',
                                showCancelButton: true,
                                cancelButtonText:'بستن',
                                onCancel:()=>{
                                    Reoverlay.hideModal();
                                    navigate('/404')
                                }
                            })
                        })
                    } else {
                        handlePayment()
                    }

                }} rounded="rounded-lg" disabled={!acceptPolicy} theme="green" className="">پرداخت</Button>

            </div>
        </BottomButtonWrapper>
    </div>
}
export default Payment;